export interface AskPodDowntimePopupInterface {
    title?: string;
    message?: string;
}

export class AskPodDowntimePopupModel {
    title: string;
    message: string;

    constructor(model: AskPodDowntimePopupInterface) {
        this.title = model.title || 'askPodPopup.downtimeTitle';
        this.message = model.message || 'askPodPopup.downtimeMessage';
    }
}
